
import {
  defineComponent, computed, ref, toRef,
} from '@vue/composition-api';
import ScreePlot from '@/components/vis/ScreePlot.vue';
import VisTile from '@/components/vis/VisTile.vue';
import ScreePlotHelp from './help/ScreePlotHelp.vue';
import usePlotData from './use/usePlotData';

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  components: {
    ScreePlot,
    ScreePlotHelp,
    VisTile,
  },

  setup(props) {
    const showCutoffs = ref(true);
    const numComponentsText = ref('10');
    const numComponents = computed(() => Number.parseInt(numComponentsText.value, 10));

    const { plot } = usePlotData(toRef(props, 'id'), 'pca');

    return {
      numComponentsText,
      numComponents,
      showCutoffs,
      plot,
    };
  },
});
